import {
  SessionCreateInterface,
  SessionRegisterPostInterface,
} from "features/auth/types";
import api from "tools/api";
import { EndpointList } from "tools/config";

export const AppService = api.injectEndpoints({
  endpoints: (build) => ({
    editUser: build.mutation<
      SessionCreateInterface,
      SessionRegisterPostInterface
    >({
      query: (data) => {
        // console.log('=-=-=-=', data);
        const body = {
          email: data.email,
          fname: data.full_name,
          lname: data.last_name,
          phone: data.contact || "",
        };
        return {
          url: `${EndpointList.UPDATE_PROFILE}/${data?.id}`,
          method: "PUT",
          // redirect: 'follow',
          body,
        };
      },
      invalidatesTags: [EndpointList.UPDATE_PROFILE, EndpointList.LOGIN],
    }),
    addNote: build.mutation<any, any>({
      query: (data) => {
        return {
          url: EndpointList.NOTE,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [EndpointList.NOTE],
    }),
    getNotes: build.query<any, any>({
      query: (userId) => `${EndpointList.NOTE}/${userId}`,
      providesTags: [EndpointList.NOTE],
    }),
    deleteNote: build.mutation<any, any>({
      query: (id) => {
        return {
          url: `${EndpointList.NOTE}/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [EndpointList.NOTE],
    }),
    addBookmark: build.mutation<any, any>({
      query: (data) => {
        return {
          url: EndpointList.BOOKMARK,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [EndpointList.BOOKMARK],
    }),
    getBookmarks: build.query<any, number>({
      query: (userId) => `${EndpointList.BOOKMARK}/${userId}`,
      providesTags: [EndpointList.BOOKMARK],
    }),
    deleteBookmark: build.mutation<any, any>({
      query: (id) => {
        return {
          url: `${EndpointList.BOOKMARK}/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [EndpointList.BOOKMARK],
    }),
  }),
  overrideExisting: false,
});

export const {
  useEditUserMutation,
  useAddBookmarkMutation,
  useAddNoteMutation,
  useGetBookmarksQuery,
  useGetNotesQuery,
  useDeleteBookmarkMutation,
  useDeleteNoteMutation,
} = AppService;
